<style scoped></style>
<template>
  <div class="app-archive">
    <h1>App归档查询</h1>
    <div class="filters">
      <label for="archive-time">归档时间：</label>
      <date-picker type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择开始时间"
        v-model="startTime"></date-picker>
      至
      <date-picker type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择结束时间"
        v-model="endTime"></date-picker>
      <Button style="margin-left:10px" type="primary" @click="search">搜索</Button>
    </div>
    <!-- 查询结果展示 -->
    <div class="result">
      <table v-if="searchResult.length > 0">
        <thead>
          <tr>
            <th>平台类型</th>
            <th>总归档个数</th>
            <th>自动构建个数</th>
            <th>自动构建占比</th>
            <th>手动构建个数</th>
            <th>手动构建占比</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in searchResult" :key="index">
            <td>{{ item.platform }}</td>
            <td>{{ item.total }}</td>
            <td>{{ item.autoCount }}</td>
            <td>{{ item.autoRatio }}</td>
            <td>{{ item.manualCount }}</td>
            <td>{{ item.manualRatio }}</td>
          </tr>
        </tbody>
      </table>
      <p v-else>暂无查询结果</p>
    </div>
  </div>
</template>

<script>
import { alloc } from '@chenfengyuan/vue-qrcode'
import dayjs from 'dayjs'
export default {
  data() {
    return {
      selectedPlatform: 'All',
      startTime: '',
      endTime: '',
      searchResult: [],
    }
  },
  methods: {
    search() {
      // 先移除上次的搜索结果
      this.searchResult.splice(0, this.searchResult.length);
      // 对时间做非空判断
      if (!this.startTime || !this.endTime) {
        // 时间为空，不执行搜索
        this.$Message.warning({
              title: "提示",
              content: "请选择时间范围！",
            });
        return;
      }
      let begin = dayjs(this.startTime).format('YYYY-MM-DD HH:mm:ss')
      let end = dayjs(this.endTime).format('YYYY-MM-DD HH:mm:ss')
      Promise.all([
        this.getlistbyplatform(begin, end, "iOS"),
        this.getlistbyplatform(begin, end, "Android"),
        this.getlistbyplatform(begin, end, "H5")
      ]).then(() => {
        this.getalldata()
      })
    },
    getlistbyplatform(begin, end, platform) {
      return new Promise((resolve, reject) => {
        let _this = this;
        let plartformmethod = ""
        switch (platform) {
          case "iOS":
            plartformmethod = "mqms/archivesearch/getioslist"
            break;
          case "Android":
            plartformmethod = "mqms/archivesearch/getandroidlist"
            break;
          case "H5":
            plartformmethod = "mqms/archivesearch/geth5list"
            break;
          default: ""
            return
        }

        this.$http.get({
          method: plartformmethod,
          params: {
            startTime: begin,
            endTime: end,
          },
          success: function (data) {
            let autoCount = 0;
            for (let i = 0; i < data.length; i++) {
              if (data[i].buildfrom == 1) {
                autoCount += 1
              }
            }
            let autoRatio = autoCount / data.length * 100;
            let autoPercentage = autoRatio.toFixed(2) + "%";
            let manualCount = data.length - autoCount;
            let manualRatio = manualCount / data.length * 100;
            let manualPercentage = manualRatio.toFixed(2) + "%";
            if (data.length == 0) {
              autoPercentage = 0
              manualPercentage = 0
            }
            let ResultItem = {
              platform: platform,
              total: data.length,
              autoCount: autoCount,
              autoRatio: autoPercentage,
              manualCount: manualCount,
              manualRatio: manualPercentage,
            }
            _this.searchResult.push(ResultItem);
            resolve()
          },
          failure(code, msg) {
            _this.$Message.warning({
              title: "提示",
              content: msg,
            });
            reject(new Error(msg))
          },
        });
      })
    },
    getalldata() {
      let _this = this;
      let allcount = 0;
      let autocount = 0;
      let manuacount = 0;
      for (let i = 0; i < _this.searchResult.length; i++) {
        let ResultItem = _this.searchResult[i]
        allcount += ResultItem.total
        autocount += ResultItem.autoCount
        manuacount += ResultItem.manualCount
      }
      let autoRatio = autocount / allcount * 100;
      let autoPercentage = autoRatio.toFixed(2) + "%";
      let manualRatio = manuacount / allcount * 100;
      let manualPercentage = manualRatio.toFixed(2) + "%";
      if (allcount == 0) {
        autoPercentage = 0
        manualPercentage = 0
      }
      let AllResultItem = {
        platform: "All",
        total: allcount,
        autoCount: autocount,
        autoRatio: autoPercentage,
        manualCount: manuacount,
        manualRatio: manualPercentage,
      }

      _this.searchResult.push(AllResultItem);
    }
  }
}
</script>

<style>
/* 样式可以根据需要进行修改 */
.app-archive {
  margin: 20px auto;
  width: 80%;
  max-width: 800px;
}

.h1 {
  font-size: 32px;
  text-align: center;
}

.filters {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
}

.label {
  margin-right: 10px;
}

.select {
  margin-right: 10px;
}

.button {
  margin-left: 10px;
}

.result table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
}

.result th,
.result td {
  padding: 12px;
  text-align: center;
  border: 1px solid #ddd;
}

.result th {
  background-color: #f5f5f5;
}

.result tbody tr:nth-child(2n) {
  background-color: #f9f9f9;
}

.result tbody tr:hover {
  background-color: #f5f5f5;
}
</style>
  